<template>
  <v-select
    class="custom_select"
    height="20"
    solo
    flat
    multiple
    :label="label"
    :item-text="itemName"
    hide-details
    :return-object="true"
    :items="items"
    :no-data-text="noDataText"
    v-model="selectedItems"
    @change="onSelectedItems"
  >
    <template v-slot:prepend-item>
      <v-list-tile v-if="items.length > 0" ripple @click="toggleItems">
        <v-list-tile-action>
          <v-icon :color="selectedItems.length > 0 ? 'primary' : ''">
            {{ iconTotal }}
          </v-icon>
        </v-list-tile-action>
        <v-list-tile-content>
          <v-list-tile-title
            :class="[selectedItems.length > 0 ? 'primary--text' : '']"
          >
            Todos
          </v-list-tile-title>
        </v-list-tile-content>
      </v-list-tile>
    </template>
    <template v-slot:selection="{ item, index }">
      <div v-if="index === 0">
        <span v-if="selectedItems.length === 1">
          {{ item[itemName] }}
        </span>
        <span
          v-else-if="
            selectedItems.length > 1 && selectedItems.length < items.length
          "
        >
          (+{{ selectedItems.length }} filtros)
        </span>
        <span v-else-if="selectedItems.length === items.length">Todos</span>
      </div>
    </template>
  </v-select>
</template>

<script>
export default {
  props: {
    items: {
      type: Array,
      default: [],
    },
    selectedItems: {
      type: Array,
      default: [],
    },
    itemName: {
      type: String,
      default: '',
    },
    label: {
      type: String,
      default: '',
    },
    noDataText: {
      type: String,
      default: 'Sin datos',
    },
  },
  data: () => ({
    items: [],
    selectedItems: [],
  }),
  methods: {
    onSelectedItems() {
      this.$emit('onSelectedItems', this.selectedItems)
    },
    toggleItems() {
      if (this.selectedItems.length) {
        this.selectedItems = []
        this.onSelectedItems()
      } else {
        this.selectedItems = this.items.map((e) => e).slice()
        this.onSelectedItems()
      }
    },
  },
  computed: {
    selectAll() {
      return this.selectedItems.length === this.items.length
    },
    selectSome() {
      return this.selectedItems.length > 0 && !this.selectAll
    },
    iconTotal() {
      if (this.selectAll) return 'disabled_by_default'
      if (this.selectSome) return 'indeterminate_check_box'
      return 'check_box_outline_blank'
    },
  },
}
</script>
<style scoped>
::v-deep .v-input.custom_select.v-text-field.v-text-field--enclosed {
  border: 1px solid var(--gray-300, #d1d5db);
  border-radius: 6px;
  padding: 1px;
}
</style>
